import { render } from "./about.vue?vue&type=template&id=0adbea16"
import script from "./about.js?vue&type=script&lang=js"
export * from "./about.js?vue&type=script&lang=js"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__